import { defineTheme } from "@astryxdesign/core/theme";
import { neutralTheme } from "@astryxdesign/theme-neutral/built";

/**
 * Tema Astryx da marca no Hub — mesmo "Fiscal Gold" do Monitor 360
 * (apps/monitor360-web/src/theme/monitorAstryxTheme.js). Duplicação
 * consciente entre os dois apps, como o restante do código compartilhado.
 */
export const hubGoldTheme = defineTheme({
  name: "hub-gold",
  extends: neutralTheme,
  color: { accent: "#C49A6A" },
  tokens: {
    "--color-accent": ["#C49A6A", "#DDAD7F"],
  },
  components: {
    // Texto escuro sobre o accent dourado — contraste AA (branco reprova).
    button: {
      "variant:primary": { color: "#1E293B" },
    },
  },
});
